module.exports = __webpack_public_path__ + "static/postnatal-6255b7f5fcef64f5686ce63f722978a7.png";